/**
 * <video-toggle> — play/pause button for a <video-media> whose native controls are hidden.
 */
if (!customElements.get('video-toggle')) {
  class VideoToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.container = this.closest('[data-video-container]') || this.parentElement;
      this.media = this.container?.querySelector('video-media');

      if (!this.button || !this.media) {
        this.hidden = true;
        return;
      }

      // Stops <video-media> re-enabling native controls when autoplay is refused.
      this.media.setAttribute('controls', '');

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.button.addEventListener('click', () => this.toggle(), { signal });
      this.container.addEventListener('media:play', () => this.syncPlayState(true), { signal });
      this.container.addEventListener('media:pause', () => this.syncPlayState(false), { signal });

      this.syncPlayState(this.media.hasAttribute('playing'));
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    toggle() {
      if (this.media.hasAttribute('playing')) {
        this.media.pause?.();
      } else {
        this.media.play?.();
      }
    }

    syncPlayState(isPlaying) {
      this.setAttribute('play-state', isPlaying ? 'playing' : 'paused');
      this.button.setAttribute('aria-label', isPlaying ? this.dataset.pauseLabel : this.dataset.playLabel);
    }
  }

  customElements.define('video-toggle', VideoToggle);
}
